// exports AlertRunStatus - an immutable object 'enum'
// usage: import { AlertRunStatus } from '../../enums/AlertRunStatus';
const alertRunStatus = {
    'Adding Members': 10,
    'Processing': 20,
    'Complete': 100
};
Object.freeze(alertRunStatus);
export const AlertRunStatus = alertRunStatus;